// router.js
import { createRouter, createWebHistory } from 'vue-router';

import Dashboard from './pages/DashboardAc.vue';
import Dashboard1 from './pages/DashboardAc1.vue';
import LoginScreen from './pages/LoginScreen.vue';
import ForgotPass from './pages/ForgotPass.vue';
import VerfyEmail from './pages/VerfyEmail.vue';
import SignupScreen from './pages/SignupScreen.vue';
import CamplainsScreen from './pages/CamplainsScreen.vue';
import ReviewListScreen from './pages/ReviewListScreen.vue';
import CustomerScreen from './pages/CustomerScreen.vue';
import QrcodeScreen from './pages/QrcodeScreen.vue';
import ReferalScreen from './pages/ReferalScreen.vue';
import TempScreen from './pages/TempScreen.vue';
import AnalyticScreen from './pages/AnalyticScreen.vue';
import SettingScreen from './pages/SettingScreen.vue';
import NotiScreen from './pages/NotiScreen.vue';
import ReviewComp from './pages/ReviewComp.vue';
import AdminBusinesses from './pages/AdminBusinesses.vue';
import AdminSubscriptions from './pages/AdminSubscriptions.vue';
import AdminUsers from './pages/AdminUsers.vue';
import AdminSettings from './pages/AdminSettings.vue';
import NewCampaign from './pages/NewCampaign.vue';
import NewRefCampaign from './pages/NewRefCampaign.vue';
import ReferralComp from './pages/ReferralComp.vue';
import RefCampaignLeads from './pages/RefCampaignLeads.vue';
import ThankYou from './pages/ThankYou.vue';


const routes = [
  {
    path: '/',
    name: 'Home',
    component: Dashboard
  },
   {
    path: '/home1',
    name: 'Home1',
    component: Dashboard1
  },
    {
      path: '/admin/businesses',
      name: 'AdminBusinesses',
      component: AdminBusinesses
    },
     {
      path: '/campaign/new',
      name: 'NewCampaign',
      component: NewCampaign
    },
     {
      path: '/campaign/ref/new',
      name: 'NewRefCampaign',
      component: NewRefCampaign
    },
     {
      path: '/campaign/ref/leads',
      name: 'RefCampaignLeads',
      component: RefCampaignLeads
    },
    {
      path: '/admin/subscriptions',
      name: 'AdminSubscriptions',
      component: AdminSubscriptions
    },
    {
      path: '/admin/users',
      name: 'AdminUsers',
      component: AdminUsers
    },
    {
      path: '/thank-you',
      name: 'ThankYou',
      component: ThankYou
    },
    {
      path: '/admin/settings',
      name: 'AdminSettings',
      component: AdminSettings
    }
    ,
  {
    path: '/login',
    name: 'LoginScreen',
    component: LoginScreen
  },
  {
    path: '/forgot-password',
    name: 'ForgotPass',
    component: ForgotPass
  },
  {
    path: '/verify-email',
    name: 'VerfyEmail',
    component: VerfyEmail
  },
  {
    path: '/create-account',
    name: 'SignupScreen',
    component: SignupScreen
  },
  {
    path: '/camplain-list',
    name: 'CamplainsScreen',
    component: CamplainsScreen
  },
  {
    path: '/review-list',
    name: 'ReviewListScreen',
    component: ReviewListScreen
  },
  {
    path: '/customer-list',
    name: 'CustomerScreen',
    component: CustomerScreen
  },
  {
    path: '/qr-code',
    name: 'QrcodeScreen',
    component: QrcodeScreen
  },
  {
    path: '/reffrals',
    name: 'ReferalScreen',
    component: ReferalScreen
  },
  {
    path: '/templetes',
    name: 'TempScreen',
    component: TempScreen
  },
  {
    path: '/analytics',
    name: 'AnalyticScreen',
    component: AnalyticScreen
  },
  {
    path: '/settings',
    name: 'SettingScreen',
    component: SettingScreen
  },
  {
    path: '/notifications',
    name: 'NotiScreen',
    component: NotiScreen
  },
  {
    path: '/review/:inf_id',
    name: 'ReviewComp',
    component: ReviewComp
  },
  {
    path: '/referral/:ref_id',
    name: 'ReferralComp',
    component: ReferralComp
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

router.beforeEach((to, from, next) => {
  const ldataRaw = sessionStorage.getItem('ldata');
  const ldata = ldataRaw ? JSON.parse(ldataRaw) : null;
  // const segments = window.location.pathname.split("/").filter(seg => seg !== "")+"";
  if (
    to.path.includes("referral") ||
    to.path.includes("review") ||
    to.path.includes("create-account") ||
    to.path.includes("forgot-password") ||
    to.path.includes("thank-you")
  ) {
    return next();
  }


  if (!to.path.includes("login") && !ldata) {
    return next("/login");
  }

  if (to.path.includes("login") && ldata) {
    if (ldata.user_type === "admin") return next("/home1");
    return next("/");
  }

  if (to.path === "/home" && ldata && ldata.user_type === "admin") {
    return next("/home1");
  }

  if (to.path === "/" && ldata && ldata.user_type === "admin") {
    return next("/home1");
  }

  if (to.path === "/home1" && ldata && ldata.user_type === "user") {
    return next("/home");
  }

  next();
});



export default router;
